export const MIN_DOWN_INELIGIBLE_FLAG = "min_down_ineligible";

export const PRODUCT_MINIMUM_NOT_MET_LABEL = "Product minimum not met";

export function hasMinDownIneligibleFlag(
  reviewFlags: readonly string[] | undefined,
) {
  return reviewFlags?.includes(MIN_DOWN_INELIGIBLE_FLAG) ?? false;
}
